import React from 'react';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    chip: {
        margin: theme.spacing(1),
    },
});

class Tag extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    deleteTag = (event) => {
        event.preventDefault();
        this.props.handleDeleteTag(this.props.tag);
    }

    render() {
        return (
            <Chip
                label={this.props.tag}
                onDelete={this.deleteTag}
                className={this.props.classes.chip}
            />
        );
    }
};

Tag.propTypes = {
    handleDeleteTag: PropTypes.func.isRequired,
    tag: PropTypes.string.isRequired,
    classes:PropTypes.object.isRequired,
};

export default withStyles(styles)(Tag);
